import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { POSTS } from "@/data/posts";
import { PostCard } from "@/pages/Blog";
import { Reveal } from "@/components/landing/Reveal";

export const BlogTeaser = () => {
  return (
    <section id="blog" className="scroll-mt-20 bg-splurge-bg py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <Reveal>
              <p className="text-xs font-extrabold uppercase tracking-[0.22em] text-splurge-primary">
                From the blog
              </p>
            </Reveal>
            <Reveal delay={80}>
              <h2 className="mt-4 max-w-2xl text-4xl font-extrabold leading-[1.08] tracking-tight text-splurge-ink sm:text-5xl">
                Money tips made for{" "}
                <span className="text-splurge-primary">student life.</span>
              </h2>
            </Reveal>
          </div>
          <Reveal delay={160}>
            <Link
              to="/blog"
              data-testid="blog-view-all"
              className="inline-flex shrink-0 items-center gap-2 rounded-full border border-splurge-ink/12 bg-white px-6 py-3 text-sm font-bold text-splurge-ink transition-all duration-200 hover:-translate-y-0.5 hover:border-splurge-primary/40 hover:text-splurge-primary active:scale-95"
            >
              View all articles
              <ArrowRight className="h-4 w-4" aria-hidden="true" />
            </Link>
          </Reveal>
        </div>

        <div className="mt-14 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {POSTS.slice(0, 3).map((post, i) => (
            <Reveal key={post.slug} delay={i * 110}>
              <PostCard post={post} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
